module.exports = __webpack_public_path__ + "img/separator-green-double.63cd04d5.svg";